import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.731 19h11.539a1 1 0 0 0 .866 -1.5l-5.769 -10a1 1 0 0 0 -1.732 0l-5.769 10a1 1 0 0 0 .865 1.5","key":"svg-0"}],["path",{"d":"M2 13h4.45","key":"svg-1"}],["path",{"d":"M18 5l-4.5 6","key":"svg-2"}],["path",{"d":"M22 9l-7.75 3.25","key":"svg-3"}],["path",{"d":"M22 15l-7 -1.5","key":"svg-4"}]]

const IconPrismLight = createReactComponent('outline', 'prism-light', 'PrismLight', __iconNode);

export default IconPrismLight;